module.exports = __webpack_public_path__ + "img/radio-nasional.21cbcdbf.jpg";